import _extends from "@babel/runtime-corejs3/helpers/extends";
import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@unite-us/ui';
import _ from 'lodash';
import EnumSelect from '../../../common/EnumSelect';
import { Field, Form } from 'react-final-form';
import { callbacks, getAdapter, trackEvent } from '../../../../config/api';
import enums from '../../../../constants/enums';
import callOrLog from '../../../../constants/callOrLog';
import { FACESHEET } from '../../../../constants/eventConstants';
import { isRequired } from '../../../utils/validations';
function EditMaritalInformation(props) {
  var contact = props.contact;
  var onSubmit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(value) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getAdapter('coreApi').updateRecord("person", contact.id, {
              marital_status: value.marital_status
            });
          case 2:
            callOrLog(function () {
              return trackEvent(FACESHEET.maritalStatusUpdated);
            });
            props.closeModal();
            callbacks.onClientSaved();
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function onSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit,
    initialValues: contact,
    render: function render(_ref2) {
      var handleSubmit = _ref2.handleSubmit,
        submitting = _ref2.submitting;
      return /*#__PURE__*/React.createElement("form", {
        className: "edit-marital-information content-with-actions",
        onSubmit: handleSubmit
      }, /*#__PURE__*/React.createElement("div", {
        className: "content-container content-container--medium"
      }, /*#__PURE__*/React.createElement(Field, {
        name: "marital_status",
        validate: isRequired
      }, function (params) {
        return /*#__PURE__*/React.createElement(EnumSelect, _extends({
          id: "contact-maritial-status",
          className: "form-control",
          clearable: false,
          enums: enums.people.marital_status,
          label: "Marital Status",
          inline: false
        }, params));
      })), /*#__PURE__*/React.createElement("div", {
        className: "actions"
      }, /*#__PURE__*/React.createElement("span", {
        className: "action-item"
      }, /*#__PURE__*/React.createElement(Button, {
        id: "edit-marital-cancel-btn",
        onClick: props.closeModal,
        disabled: submitting,
        label: "Cancel"
      })), /*#__PURE__*/React.createElement("span", {
        className: "action-item"
      }, /*#__PURE__*/React.createElement(Button, {
        id: "edit-marital-save-btn",
        disabled: submitting,
        label: "Save",
        primary: true,
        type: "submit"
      }))));
    }
  });
}
EditMaritalInformation.propTypes = {
  closeModal: PropTypes.func,
  contact: PropTypes.object.isRequired
};
export default EditMaritalInformation;
//# sourceMappingURL=EditMaritalInformation.js.map